import React, {useContext} from 'react';
import {ReactComponent as Done} from './done.svg';
import {ReactComponent as AppStore} from './appStore.svg';
import {ReactComponent as GoogleStore} from './googleStore.svg';
import './Finish.scss';
import {Context} from '../@context/Context';
import {setMetrics} from "../ecommerce";

// import { onChange } from '../@helper/common/common';

const loginWith = (auth) => {
    if (auth.account === 'facebook') {
        return (<div className="finish__text-block">
            <p className="finish__text">1. Download and launch <span className="finish__text-green">GeoZilla App </span></p>
            <p className="finish__text">2. In the App, Sign In with your <span
                className="finish__text-fb">Facebook</span></p>
        </div>);
    }
    if (auth.account === 'google') {
        return (
            <div className="finish__text-block">
                <p className="finish__text">1. Download and launch <span className="finish__text-green">GeoZilla App </span></p>
                <p className="finish__text">2. In the App, Sign In with your Google Account</p>
            </div>
            );
    }
    if (auth.account === 'email') {
        return (
            <div className="finish__text-block">
                <p className="finish__text"><span className="finish__text-green">1.</span> Please confirm your email</p>
                <p className="finish__text"><span className="finish__text-green">2.</span> Set a password using the link sent to you via email</p>
                <p className="finish__text"><span className="finish__text-green">3.</span> Download GeoZilla and log in using your email and password</p>
            </div>
        );
    }
};

const Finish = () => {
    const {
        state: {
            auth,
            // email
        },
        // actions: {
        //     setEmail
        // }
    } = useContext(Context);

    setMetrics();
    // const valueEmail = auth.data ? auth.data.email : '';
    // const emailSubscribe = email ? email : valueEmail;


    return (
        <div className="container container__center">
            <div className="finish">
                <div className="finish__center">
                    <Done/>
                    <h1 className="finish__title">Your payment has been successfully completed</h1>
                    <p className="finish__text finish__text-bold finish__text-first finish__text-green">What’s next</p>

                    {
                        loginWith(auth)
                    }
                    <div className="finish__app">
                        <a href="https://bnc.lt/geozilla_app_store" className="finish__app-btn">
                            <AppStore/>
                        </a>
                        <a href="https://bnc.lt/geozilla_google_play" className="finish__app-btn">
                            <GoogleStore/>
                        </a>
                    </div>
                    {/* <div className="finish__done">
                        <input className="finish__input" value={emailSubscribe} onChange={onChange(setEmail)} />
                        <button className="finish__btn">Send</button>
                    </div> */}
                    <img className="finish__phone-logo" alt="phone" src="/images/phone.png"/>
                </div>
            </div>
        </div>
    );
};

export default Finish;
